import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CurrencyState {
  currencyCode: string;
}

const initialState: CurrencyState = {
  currencyCode: localStorage.getItem("currencyCode") || "USD",
};

const currencyCodeSlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    setCurrencyCode: (state, action: PayloadAction<string>) => {
      state.currencyCode = action.payload;
      localStorage.setItem("currencyCode", action.payload);
    }
  }
});

export const { setCurrencyCode } = currencyCodeSlice.actions;
export default currencyCodeSlice.reducer;
